import React from 'react'
import Hero from './Hero/Hero'
import Featured from './featured/Featured'
import Location from './location/Location'


const Home = () => {
  return (
<>   <Hero/>
          <Featured/>

   <Location/>
   </>
  )
}

export default Home
